import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  defaultFont
} from "assets/jss/material-dashboard-react.js";

const tableStyle = theme => ({
  warningTableHeader: {
    color: warningColor[0]
  },
  primaryTableHeader: {
    color: primaryColor[0]
  },
  dangerTableHeader: {
    color: dangerColor[0]
  },
  successTableHeader: {
    color: successColor[0]
  },
  infoTableHeader: {
    color: infoColor[0]
  },
  roseTableHeader: {
    color: roseColor[0]
  },
  grayTableHeader: {
    color: grayColor[0]
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse"
  },
  tableHeadCell: {
    color: "inherit",
    ...defaultFont,
    "&, &$tableCell": {
      fontSize: "1em"
    }
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px",
    verticalAlign: "middle",
    fontSize: "0.8125rem"
  },
  tableResponsive: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto"
  },
  tableHeadRow: {
    height: "56px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle"
  },
  tableBodyRow: {
    height: "48px",
    color: "inherit",
    display: "table-row",
    outline: "none",
    verticalAlign: "middle"
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: "0px !important"
  },
  tableTitle: {
    paddingLeft: 25,
    paddingTop: 25,
    color: "inherit",
    fontFamily : " 'Helvetica Neue','Arial',sans-serif",
    fontSize: '1rem',
    fontWeight: 700
  },
  tableBodyData : {
    verticalAlign: "middle", color: '#333 !important', fontSize : "0.85rem",
    textTransform :'none',
    '& .MuiTypography-root' :{
      textTransform :'none',
      fontWeight : 600
    }
  },
  arrowDropIcon :{
    color: '#333'
  },
  tableNoRecord: {
    paddingLeft : "25px",
    paddingTop : "25px",
    color :"text",
    width : "200px",
    fontSize: "0.9rem"
  },
  tablePaginationText: {
    color : 'rgb(0, 0, 0) !important',
    fontFamily : " 'Helvetica Neue','Arial',sans-serif",
    fontSize: '0.875rem',
    textTransform : 'inherit'
  },
  tablePagination: {
    borderRadius : '10rem',
    padding: '0.6875rem 0.6875rem 0.625rem',
    borderColor: '#dee2e6',
    margin: '0 0.125rem',
    fontWeight: 400,
    fontSize: '0.875rem',
    width: '2.25rem',
    minWidth: '2.25rem',
    height: '2.25rem',
    minHeight: '2.25rem',
    color: '#7b809a',
    '&.MuiButton-contained' : {
      color : '#ffffff'
    }
  }
});

export default tableStyle;
